<template>
    <el-table :data="data" class="w-100">
        <el-table-column type="expand">
            <template slot-scope="scope">
                <div class="row">
                    <div class="col-xl-4">
                        <p class="hint mb-1">Address Id</p>
                        <h6>{{ scope.row.id }}</h6>
                    </div>
                    <div class="col-xl-4">
                        <p class="hint mb-1">Address Line 2</p>
                        <h6>{{ scope.row[USER_ADDRESSES.fields.address2] || 'N/A' }}</h6>
                    </div>
                    <div class="col-xl-4">
                        <p class="hint mb-1">Province</p>
                        <h6>{{ scope.row[USER_ADDRESSES.fields.province] }}</h6>
                    </div>
                    <div class="col-xl-4">
                        <p class="hint mb-1">Country</p>
                        <h6>{{ scope.row[USER_ADDRESSES.fields.country] }}</h6>
                    </div>
                </div>
            </template>
        </el-table-column>
        <el-table-column :prop="USER_ADDRESSES.fields.name" label="Name"> </el-table-column>
        <el-table-column :prop="USER_ADDRESSES.fields.address1" label="Address"> </el-table-column>
        <el-table-column :prop="USER_ADDRESSES.fields.postalCode" label="Postal Code"> </el-table-column>
        <el-table-column :prop="USER_ADDRESSES.fields.city" label="City"> </el-table-column>
    </el-table>
</template>
<script>
import { USER_ADDRESSES } from 'db'
export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            USER_ADDRESSES
        }
    }
}
</script>

<style lang="scss" scoped>
.el-table table .btn {
    margin: 0 5px;
}
</style>
